import { Box } from '@mui/material';
import React from 'react';
import { SectionTitle } from '@shared/components/SectionTitle';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { colorTheme } from '@styles/muiTheme';
import { prodData, productInformationColumn } from '../constants';
import { IDSProps } from '../interfaces';

export const DealSheetProductSummary = ({ data }: IDSProps) => {
  return (
    <Box>
      <SectionTitle
        title="Product Information"
        variant="h2"
      />

      <PhoenixGrid
        autoHeight
        withHeader
        noButton
        canNotCopy
        hideFooter
        columns={productInformationColumn}
        rows={prodData(data) || []}
        sx={{ backgroundColor: colorTheme.palette.common.white }}
      />
    </Box>
  );
};
